import {
  useEffect,
  useState,
} from 'react'

import {
  Box,
  Stack,
  Heading,
  WrapItem,
  Tooltip,
} from '@chakra-ui/react'
import { 
  AiOutlineQuestionCircle,
} from 'react-icons/ai'

import Select from 'react-select'

import TripSelect from './trips/TripSelect'

function JourneyFilter({ journeys, setJourneysToDisplay, hideSortOrder = false }) {

  const [filteredJourneys, setFilteredJourneys] = useState(undefined)

  const [isYearFilterDisabled, setIsYearFilterDisabled] = useState(false)
  const [isPastUpcomingDisabled, setIsPastUpcomingDisabled] = useState(false)
  const [isTripDisabled, setIsTripDisabled] = useState(false)

  const [sortOrder, setSortOrder] = useState("descending")

  const [yearFilterOptions, setYearFilterOptions] = useState([])
  const pastUpcomingOptions = [
    { value: "all", label: "All" },
    { value: "past", label: "Past" },
    { value: "upcoming", label: "Upcoming" }
  ]

  useEffect(() => {
    const tempYears = []

    for (const journey of journeys) {
      // Year filtering
      const year = new Date(journey.date).getFullYear()
      if (!(tempYears.some(e => e.value === year))) {
        tempYears.push({ value: year, label: year })
      }
    }

    setYearFilterOptions([{ value: 'all', label: 'All' }, ...tempYears.slice().sort((a, b) => a.value - b.value)])

    setJourneysToDisplay(sortJourneys(journeys))
  }, [journeys])

  function resetFiltering() {
    setFilteredJourneys(undefined)
    setJourneysToDisplay(sortJourneys(journeys))

    setIsYearFilterDisabled(false)
    setIsPastUpcomingDisabled(false)
    setIsTripDisabled(false)
  }

  function handleFilterYearChange(e) {
    if (e.value === 'all') {
      resetFiltering()
      return
    }

    const filteredResults = journeys.filter(journey =>
      (new Date(journey.date)).getFullYear() === e.value
    )

    setFilteredJourneys(sortJourneys(filteredResults.reverse()))

    setIsPastUpcomingDisabled(true)
    setIsTripDisabled(true)
  }

  function handlePastUpcomingChange(e) {
    if (e.value === "all") {
      resetFiltering()
      return
    }

    if (e.value === "past") {
      const filteredResults = journeys.filter(journey =>
        (new Date(journey.date)) <= (new Date)
      ).reverse()

      setFilteredJourneys(sortJourneys(filteredResults))
    } else if (e.value === "upcoming") {
      const filteredResults = journeys.filter(journey =>
        (new Date(journey.date)) > (new Date)
      ).reverse()

      setFilteredJourneys(sortJourneys(filteredResults))
    }

    setIsYearFilterDisabled(true)
    setIsTripDisabled(true)
  }

  // By trip
  function handleFilterTripSubformChange(value) {
    if (!value) {
      resetFiltering()
      return
    }

    const filteredResults = journeys.filter(journey => journey.partOfTrip === value)

    setFilteredJourneys(sortJourneys(filteredResults.reverse()))

    setIsYearFilterDisabled(true)
    setIsPastUpcomingDisabled(true)
  }

  // Sorting
  const sortOrderOptions = [
    { value: "descending", label: "Descending" },
    { value: "ascending", label: "Ascending" },
    { value: "legacy-descending", label: "Legacy (Descending)" },
  ]

  function sortJourneys(journeysToSort) {
    if (sortOrder === "descending") {
      return journeysToSort.slice().reverse().sort((a, b) => new Date(b.date) - new Date(a.date))
    } else if (sortOrder === "ascending") {
      return journeysToSort.slice().sort((a, b) => new Date(a.date) - new Date(b.date))
    } else if (sortOrder === "legacy-descending") {
      return journeysToSort.slice().sort((a, b) => new Date(b.date) - new Date(a.date))
    }
  }

  function sortOrderChange(e) {
    setSortOrder(e.value)
  }

  useEffect(() => {
    if (filteredJourneys) {
      setJourneysToDisplay(sortJourneys(filteredJourneys))
    } else {
      setJourneysToDisplay(sortJourneys(journeys))
    }
  }, [sortOrder, filteredJourneys])

  return (
    <>
      <Box>
        <Stack
          direction='row'
          align='center'
          spacing={4}
          padding={2}
        >
          <Heading as='h5' fontSize='m'>
            Filter by:
          </Heading>

          <Select
            placeholder='Year'
            options={yearFilterOptions}
            onChange={handleFilterYearChange}
            isDisabled={isYearFilterDisabled}
          />

          <Select
            placeholder='Past/upcoming'
            options={pastUpcomingOptions}
            onChange={handlePastUpcomingChange}
            isDisabled={isPastUpcomingDisabled}
          />

          <TripSelect
            unassignedOptionLabel='Trip'
            setSelectedTripId={handleFilterTripSubformChange}
            isDisabled={isTripDisabled}
          />

          {(isYearFilterDisabled || isPastUpcomingDisabled || isTripDisabled) && (
            <WrapItem>
              <Tooltip
                label='Filtering is currently limited to a single property.'
                closeDelay={500}
              >
                <Box children={<AiOutlineQuestionCircle />} />
              </Tooltip>
            </WrapItem>
          )}

          { !hideSortOrder && (<>
            <Heading as='h5' fontSize='m'>
              Sort by:
            </Heading>
            <Select
              placeholder='Descending'
              options={sortOrderOptions}
              onChange={sortOrderChange}
            />
          </>)}
          </Stack>
      </Box>
    </>
  )
}

export default JourneyFilter